const initialUIState = {
    transactionFilterModal: false,
    charityThankYouModal: false,
    genericNotificationLoaded: false,
    genericNotificationMessage: "",
    genericNotificationConfirmButtonText: "",
    hideAdBanner: false,
    debugMode: false
}

const uiStateReducer = (state = initialUIState, action) => {
    switch (action.type) {
        case 'TRANSACTION_FILTER_MODAL_CHANGE':
            return Object.assign({}, state, {
                transactionFilterModal: action.newState
            })
        case 'CHARITY_THANKS_MODAL_CHANGE':
            return Object.assign({}, state, {
                charityThankYouModal: action.newState
            })
        case 'UNLOAD_GENERIC_NOTIFICATION':
            return Object.assign({}, state, {
                genericNotificationLoaded: false
            })
        case 'LOAD_GENERIC_NOTIFICATION':
            return Object.assign({}, state, {
                genericNotificationLoaded: true,
                genericNotificationMessage: action.newMessage,
                genericNotificationConfirmButtonText: "OK"
            })
        case 'ENABLE_DEBUG_MODE':
            return Object.assign({}, state, {
                debugMode: true
            })
        case 'DISABLE_DEBUG_MODE':
            return Object.assign({}, state, {
                debugMode: false
            })
        case 'DISABLE_ADBANNER':
            return Object.assign({}, state, {
                hideAdBanner: true
            })
        default:
            return state
    }
}

export default uiStateReducer;